import { useMutation } from '@tanstack/react-query'

import type { MesureResponseModel } from '@/domain/model/measures'
import { QUERIES } from '@/enums/queries'

import { globalQueryClient } from '../queryClient'
import { addNewLevel, AddNewLevelProps } from './services/addNewLevel'

type Props = {
  questionId: string
  formId: string
  clientId: string
}

export const useAddNewLevel = ({ questionId, formId, clientId }: Props) => {
  const mutation = useMutation({
    mutationFn: async (data: AddNewLevelProps) => await addNewLevel(data),
    onSuccess: (data) => {
      globalQueryClient.setQueryData<MesureResponseModel>(
        [QUERIES.MEASURES.LOAD_BY_FORM_AND_CLIENT_ID, formId, clientId],
        (old) => {
          if (!old) return old
          return {
            ...old,
            questions:
              old?.questions?.map((item) => {
                if (item.id === Number(questionId)) {
                  return {
                    ...item,
                    levels: [...(data?.levels || [])],
                  }
                }
                return item
              }) || [],
          }
        }
      )
    },
  })

  const addNewLevelReq = async (data: AddNewLevelProps) => {
    return mutation.mutateAsync(data)
  }

  return {
    addNewLevel: addNewLevelReq,
    ...mutation,
  }
}
